<div class="ask-question" *ngIf="sharedQuestions?.length > 0 || isAdmin">
  <button class="share-popup-close-btn" type="button" aria-label="Close" *ngIf="canClosePopup" (click)="closePopup()">
    <i class="fa-solid fa-xmark"></i>
  </button>
  <p class="title mb-3">{{ shareWithOtherTitle || 'Share with Others' }}</p>
  <div class="mb-2" *ngIf="isAdmin">
    <app-upload-popup-image [filter]="filter" [type]="'share-with-others'"></app-upload-popup-image>
  </div>
  <button class="btn btn-outline-primary mb-3 w-100" *ngIf="isAdmin && !sharedQuestions?.length"
    (click)="openCreateQuestionModal()">
    <i class="fa-solid fa-plus mr-2"></i>Create Question
  </button>
  <button class="btn btn-outline-primary mb-3 w-100" *ngIf="isAdmin && sharedQuestions?.length > 0"
    (click)="openEditQuestionModal(sharedQuestions[0])">
    <i class="fa-solid fa-edit mr-2"></i>Edit existing Question
  </button>

  <!-- Single Card with Users and Answers -->
  <div class="questions-single-card" *ngIf="sharedQuestions?.length > 0">
    <div class="question-card-container">
      <div class="question-item-in-card">
        <!-- Users and Answers Section -->
        <div class="users-answers-section" *ngIf="usersWithAnswers?.usersWithAnswers?.length > 0">
          <div class="users-answers-list">
            <ng-container *ngFor="let userData of usersWithAnswers.usersWithAnswers">
              <div class="user-answer-item mb-3 pb-3 border-bottom position-relative"
                (click)="openQuestionDetailModalForUser(userData)"
                style="cursor: pointer; transition: background-color 0.2s;">
                <button *ngIf="isAdmin" type="button" class="user-answer-delete-btn"
                  (click)="deleteUserAnswer(userData, $event)" aria-label="Delete user response">
                  <i class="fa-solid fa-trash"></i>
                </button>
                <!-- User Info -->
                <div class="user-info mb-2 d-flex align-items-center">
                  <img *ngIf="userData.user?.profileImage" [src]="imgUrl + userData.user.profileImage"
                    [alt]="userData.user.name || 'User'" (error)="commonService.handleError($event)"
                    class="rounded-circle me-2" style="width: 28px; height: 28px; object-fit: cover;">
                  <div *ngIf="!userData.user?.profileImage"
                    class="rounded-circle me-2 d-flex align-items-center justify-content-center bg-secondary text-white"
                    style="width: 28px; height: 28px; font-size: 0.75rem; font-weight: 600;">
                    {{ (userData.user?.name || 'A')[0]?.toUpperCase() }}
                  </div>
                  <div class="fw-semibold ml-1" style="font-size: 0.9rem;">
                    {{ userData.user?.name || 'Anonymous' }}
                  </div>
                </div>

                <!-- Answers -->
                <div class="user-answers">
                  <ng-container *ngFor="let answerItem of userData.answers; let answerIndex = index">
                    <div class="answer-item" *ngIf="answerItem.answer">
                      <div class="answer-text">
                        <div>{{ stripHtmlTags(answerItem.answer) }}</div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- Answer Button -->
        <div class="answers-summary mt-3">
          <button class="btn btn-outline-secondary w-100" (click)="openAnswerModal()">
            Share
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- See More Button -->
  <!-- <button 
    class="btn btn-outline-secondary w-100 mt-2" 
    *ngIf="sharedQuestions?.length > 3"
    (click)="openQuestionsListModal()">
    See More ({{ sharedQuestions.length }})
  </button> -->
  <!-- <button *ngIf="sharedQuestions?.length > 0" class="btn btn-outline-secondary w-100 mt-2" (click)="openAnswerModal()">
    Answer
  </button> -->

  <!-- Empty State -->
  <div class="text-center text-muted py-3"
    *ngIf="(!usersWithAnswers?.usersWithAnswers || usersWithAnswers.usersWithAnswers.length === 0) && (!sharedQuestions || sharedQuestions.length === 0)">
    <p>No answers yet.</p>
  </div>
</div>

<!-- Create Question Modal Template -->
<ng-template #askQuestionAboutCategory>
  <div class="ask-question">
    <p class="title mb-3">Ask Question</p>

    <!-- Booking Questions Form (matching edit-booking structure) -->
    <div class="edit-booking-questions">
      <div *ngFor="let qn of createQuestionForm; let i = index" class="edit-booking-question-card">
        <div class="edit-booking-question-card__header" *ngIf="createQuestionForm?.length > 1">
          <button class="edit-booking-question-card__remove" (click)="removeQuestionFromForm(i)">
            <i class="fa-solid fa-trash"></i>
          </button>
        </div>

        <div class="edit-booking-question-card__content">
          <div class="form-group">
            <label class="form-label">Question Text</label>
            <input type="text" class="form-control" [(ngModel)]="qn.questionText" placeholder="Enter question text" />
          </div>

          <div class="form-group">
            <label class="form-label">Answer Type</label>
            <select class="form-control py-0" [(ngModel)]="qn.type">
              <option value="text">Text Input</option>
              <option value="multipleChoice">Multiple Choice</option>
              <option value="singleDate">Single Date</option>
              <option value="dateRange">Date Range</option>
            </select>
          </div>

          <button *ngIf="qn.type === 'multipleChoice'" class="btn btn-outline-primary btn-sm"
            (click)="addChoiceToQuestion(i)">
            <i class="fa-solid fa-plus me-1"></i>
            Add Choice
          </button>
        </div>

        <!-- Multiple Choice Options -->
        <div class="edit-booking-choices" *ngIf="qn.type === 'multipleChoice'">
          <div class="edit-booking-choices__list">
            <div class="edit-booking-choice-item"
              *ngFor="let choice of qn.choices; let j = index; trackBy: trackByChoice">
              <input type="text" class="form-control" [(ngModel)]="qn.choices[j]" placeholder="Choice {{ j + 1 }}" />
              <button class="edit-booking-choice-item__remove" (click)="removeChoiceFromQuestion(i, j)">
                <i class="fa-solid fa-times"></i>
              </button>
            </div>
          </div>
          <div class="edit-booking-choices__empty" *ngIf="qn.choices.length === 0">
            <i class="fa-solid fa-info-circle me-2"></i>
            No choices yet — please add one.
          </div>
        </div>
      </div>

      <div class="edit-booking-questions__empty" *ngIf="createQuestionForm.length === 0">
        <i class="fa-solid fa-question-circle me-2"></i>
        No questions yet — please add one.
      </div>

      <button class="btn btn-primary mb-3" (click)="addNewQuestionToForm()">
        <i class="fa-solid fa-plus me-1"></i>
        Add Question
      </button>
    </div>

    <button class="my-2 btn btn-outline-primary w-100" (click)="addQuestionToForumMap()">
      <i class="fa-solid fa-plus mr-2"></i>Add Question
    </button>
  </div>
</ng-template>

<!-- Question Detail Modal Template -->
<ng-template #questionDetailModal>
  <div class="question-detail-modal-content">
    <div class="modal-header border-bottom pb-3 mb-3">
      <h5 class="modal-title">Question Details</h5>
      <button type="button" class="btn-close" (click)="questionDetailModalRef?.close()" aria-label="Close">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>

    <div class="modal-body" *ngIf="selectedQuestion">
      <!-- Question Header -->
      <div class="question-header mb-4 pb-3 border-bottom" *ngIf="isAdmin">
        <div class="d-flex justify-content-between align-items-start">
          <div>
            <h6 class="mb-2">
              <i class="fa-solid fa-circle-question mr-2"></i>Question
            </h6>
            <small class="text-muted" *ngIf="selectedQuestion.createdAt">
              <i class="fa-solid fa-clock mr-1"></i>{{ formatDate(selectedQuestion.createdAt) }}
            </small>
          </div>
          <div class="question-actions" *ngIf="isAdmin">
            <button class="btn btn-sm btn-outline-primary mr-2" (click)="openEditQuestionModal(selectedQuestion)">
              <i class="fa-solid fa-edit mr-1"></i>Edit
            </button>
            <button class="btn btn-sm btn-outline-danger" (click)="deleteQuestion(selectedQuestion)">
              <i class="fa-solid fa-trash mr-1"></i>Delete
            </button>
          </div>
        </div>
      </div>

      <!-- Replies -->
      <div class="replies-section">
        <ng-container *ngIf="getRepliesForQuestion(selectedQuestion.id) as replies">
          <div class="replies-list" *ngIf="replies.length > 0">
            <ng-container *ngFor="let reply of replies">
              <div class="reply-item mb-4 pb-4 border-bottom">
                <!-- User Info -->
                <div class="reply-user-info mb-3 d-flex align-items-center">
                  <img *ngIf="reply?.user?.profileCharacterImageFile"
                    [src]="imgUrl + reply?.user.profileCharacterImageFile"
                    [alt]="reply?.user.profileCharacterName || 'User'" (error)="commonService.handleError($event)"
                    class="rounded-circle me-2" style="width: 32px; height: 32px; object-fit: cover;">
                  <div *ngIf="!reply?.user?.profileCharacterImageFile"
                    class="rounded-circle me-2 d-flex align-items-center justify-content-center bg-secondary text-white"
                    style="width: 32px; height: 32px; font-size: 0.85rem; font-weight: 600;">
                    {{ (reply?.user?.profileCharacterName || 'A')[0]?.toUpperCase() }}
                  </div>
                  <div class="ml-2">
                    <div class="fw-semibold" style="font-size: 0.9rem;">
                      {{ reply?.user?.profileCharacterName || 'Anonymous' }}
                    </div>
                    <small class="text-muted" *ngIf="reply.createdAt" style="font-size: 0.75rem;">
                      <i class="fa-solid fa-clock mr-1"></i>{{ formatDate(reply.createdAt) }}
                    </small>
                  </div>
                </div>

                <!-- Question-Answer Pairs -->
                <div class="question-answer-pairs">
                  <ng-container *ngFor="let pair of selectedQuestion?.parsedQuestions || []; let pairIndex = index">
                    <div class=" qa-pair mb-4">
                      <div class="qa-question mb-2 fw-semibold text-dark">
                        {{ pair?.questionText || pair?.question || 'Question' }}
                      </div>
                      <div class="qa-answer text-muted d-flex align-items-start" style="gap: 0.75rem;">
                        <div class="answer-number">{{ pairIndex + 1 }}</div>
                        <div>{{ stripHtmlTags(reply?.parsedTextArray?.[pairIndex] || '') || 'No answer provided' }}
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>

                <!-- Reply Footer -->
                <div class="reply-footer mt-3 d-flex justify-content-end" *ngIf="false">
                  <div class="d-flex gap-2">
                    <button class="btn btn-sm btn-outline-primary mr-1" (click)="startReplyingToReply(reply.id)">
                      <i class="fa-solid fa-reply mr-1"></i>Reply
                    </button>
                    <button class="btn btn-sm btn-outline-danger" *ngIf="isAdmin" (click)="deleteReply(reply)">
                      <i class="fa-solid fa-trash mr-1"></i>Delete
                    </button>
                  </div>
                </div>

                <!-- Nested Replies -->
                <div class="nested-replies mt-3 ms-3 ps-3 border-start"
                  *ngIf="reply.replies && reply.replies.length > 0">
                  <div class="nested-reply-item mb-3" *ngFor="let nestedReply of reply.replies">
                    <div class="nested-reply-content">
                      <!-- Nested Reply User Info -->
                      <div class="d-flex align-items-center mb-2">
                        <img *ngIf="nestedReply?.user?.profileCharacterImageFile"
                          [src]="imgUrl + nestedReply?.user.profileCharacterImageFile"
                          [alt]="nestedReply?.user.profileCharacterName || 'User'"
                          (error)="commonService.handleError($event)" class="rounded-circle me-2"
                          style="width: 24px; height: 24px; object-fit: cover;">
                        <div *ngIf="!nestedReply?.user?.profileCharacterImageFile"
                          class="rounded-circle me-2 d-flex align-items-center justify-content-center bg-secondary text-white"
                          style="width: 24px; height: 24px; font-size: 0.7rem; font-weight: 600;">
                          {{ (nestedReply?.user?.profileCharacterName || 'A')[0]?.toUpperCase() }}
                        </div>
                        <div class="ml-2">
                          <span class="fw-semibold" style="font-size: 0.85rem;">
                            {{ nestedReply?.user?.profileCharacterName || 'Anonymous' }}
                          </span>
                          <small class="text-muted ms-2" *ngIf="nestedReply.createdAt" style="font-size: 0.75rem;">
                            <i class="fa-solid fa-clock mr-1"></i>{{ formatDate(nestedReply.createdAt) }}
                          </small>
                        </div>
                      </div>
                      <div class="nested-reply-text mb-2" [innerHTML]="getReplyDisplayText(nestedReply)"></div>
                      <div class="nested-reply-footer d-flex justify-content-end">
                        <button class="btn btn-sm btn-outline-danger" *ngIf="isAdmin"
                          (click)="deleteReply(nestedReply); $event.stopPropagation()">
                          <i class="fa-solid fa-trash mr-1"></i>Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Reply Form -->
                <div class="reply-to-reply-form mt-3" *ngIf="isReplyingToReply(reply.id)">
                  <textarea rows="3" placeholder="Write your reply..." [value]="getReplyTextForReply(reply.id)"
                    (input)="setReplyTextForReply(reply.id, $any($event.target).value)" class="form-control mb-2">
                  </textarea>
                  <div class="d-flex gap-2 justify-content-end">
                    <button class="btn btn-sm btn-outline-secondary mr-1" (click)="cancelReplyToReply(reply.id)">
                      Cancel
                    </button>
                    <button class="btn btn-sm btn-secondary" (click)="addReply(selectedQuestion.id, reply.id)">
                      <i class="fa-solid fa-paper-plane mr-1"></i>Post Reply
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="text-center py-5" *ngIf="replies.length === 0">
            <i class="fa-solid fa-comment-slash fa-2x mb-2 text-muted d-block"></i>
            <p class="text-muted mb-0">No replies yet. Be the first to reply!</p>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<!-- Questions List Modal Template -->
<ng-template #questionsListModal>
  <div class="questions-list-modal-content">
    <div class="modal-header border-bottom pb-3 mb-3">
      <h5 class="modal-title">All Questions</h5>
      <button type="button" class="btn-close" (click)="modalService.dismissAll()" aria-label="Close">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <div class="questions-list-full" *ngIf="sharedQuestions?.length > 0">
        <div class="question-item-full mb-3 p-3" *ngFor="let question of sharedQuestions; let i = index">
          <div class="d-flex justify-content-between align-items-start">
            <div class="flex-grow-1" (click)="openQuestionFromList(question)">
              <p class="mb-2 question-text-full">
                {{ stripHtmlTags(question.displayQuestionText || question.questionText || question.text) }}
              </p>
              <div class="d-flex justify-content-between align-items-center">
                <small class="text-muted question-date" *ngIf="question.createdAt">
                  {{ formatDate(question.createdAt) }}
                </small>
                <small class="text-muted reply-count"
                  *ngIf="question.replyCount !== undefined && question.replyCount !== null && question.replyCount > 0">
                  <i class="fa-solid fa-comments mr-1"></i>{{ getReplyCount(question) }} {{ getReplyCount(question) ===
                  1 ? 'reply' : 'replies' }}
                </small>
              </div>
            </div>
            <div class="question-actions ml-3" *ngIf="isAdmin" (click)="$event.stopPropagation()">
              <button class="btn btn-sm btn-outline-primary mr-2" (click)="openEditQuestionModal(question)">
                <i class="fa-solid fa-edit mr-1"></i>Edit
              </button>
              <button class="btn btn-sm btn-outline-danger" (click)="deleteQuestion(question)">
                <i class="fa-solid fa-trash mr-1"></i>Delete
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center text-muted py-5" *ngIf="!sharedQuestions || sharedQuestions.length === 0">
        <p>No questions yet. Be the first to share!</p>
      </div>
    </div>
  </div>
</ng-template>

<!-- Answer Modal Template -->
<ng-template #answerModal>
  <div class="answer-modal-content">
    <div class="modal-header border-bottom pb-3 mb-3">
      <h5 class="modal-title">Answer Questions</h5>
      <button type="button" class="btn-close" (click)="closeAnswerPopup()" aria-label="Close">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>

    <div class="stacked-image">
      <img [src]="imgUrl + popupImage?.image" (error)="commonService.handleError($event)" alt="">
    </div>

    <div class="modal-body">
      <div class="booking-details" *ngIf="answerQuestions?.length">
        <form #answerForm="ngForm">
          <ng-container *ngFor="let qn of answerQuestions; let i = index; trackBy: trackByQuestion">
            <div class="mb-2">
              <ng-container *ngIf="qn.choices?.length && qn.type === 'multipleChoice'">
                <div class="form-floating" [class.filled]="qn.answer"
                  [ngClass]="((qn.question ?? qn.questionText ?? 'Question ' + (i + 1))?.length || 0) > 69 ? 'long-label' : 'short-label'">
                  <select class="form-select" [(ngModel)]="qn.answer" name="choice{{ i }}" id="choice{{ i }}"
                    aria-label="Answer for question {{ i + 1 }}">
                    <option *ngFor="let choice of qn.choices; let j = index; trackBy: trackByChoice" [ngValue]="choice">
                      {{ choice }}
                    </option>
                  </select>
                  <label for="choice{{ i }}">{{ qn.question ?? qn.questionText ?? "Question " + (i + 1) }}</label>
                </div>
              </ng-container>

              <div class="form-floating mt-2" *ngIf="qn?.type == 'text'" [class.filled]="qn.answer"
                [ngClass]="((qn.question ?? qn.questionText ?? 'Question ' + (i + 1))?.length || 0) > 69 ? 'long-label' : 'short-label'">
                <input type="text" class="form-control" [(ngModel)]="qn.answer" name="text{{ i }}" id="text{{ i }}"
                  placeholder=" " />
                <label for="text{{ i }}">{{ qn.question ?? qn.questionText ?? "Question " + (i + 1) }}</label>
              </div>

              <div *ngIf="qn.type === 'singleDate'" [class.filled]="qn.answer"
                [ngClass]="((qn.question ?? qn.questionText ?? 'Question ' + (i + 1))?.length || 0) > 69 ? 'long-label' : 'short-label'">
                <label for="date{{ i }}">{{ qn.question ?? qn.questionText ?? "Question " + (i + 1) }}</label>
                <input type="date" class="form-control" id="date{{ i }}" placeholder=" "
                  (change)="qn.answer = $event.target?.value?.toString()" />
              </div>
              <div *ngIf="qn.type === 'dateRange'" class="mt-2"
                style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem">
                <label for="fromDate{{ i }}">From</label>
                <input type="date" class="form-control" id="fromDate{{ i }}" placeholder=" " #fromDate
                  (change)="qn.answer = $event.target?.value?.toString() + '-' + (toDate?.value?.toString() || '')" />

                <label for="toDate{{ i }}">To</label>
                <input type="date" class="form-control" id="toDate{{ i }}" placeholder=" " #toDate
                  (change)="qn.answer = (fromDate?.value?.toString() || '') + '-' + $event.target?.value?.toString()" />
              </div>
            </div>
          </ng-container>
        </form>
      </div>

      <div class="text-center text-muted py-3" *ngIf="!answerQuestions || answerQuestions.length === 0">
        <p>No questions available</p>
      </div>
    </div>

    <div class="modal-footer border-top pt-3">
      <button type="button" class="btn btn-outline-secondary" (click)="closeAnswerPopup()">
        <i class="fa-solid fa-times mr-1"></i>
        Cancel
      </button>
      <button type="button" class="btn btn-outline-primary" (click)="submitAnswers()">
        <i class="fa-solid fa-paper-plane mr-1"></i>
        Submit
      </button>
    </div>
  </div>
</ng-template>

<!-- Edit Question Modal Template -->
<ng-template #editQuestionModal>
  <div class="ask-question">
    <div class="modal-header border-bottom pb-3 mb-3 d-flex justify-content-between align-items-center">
      <h5 class="modal-title">Edit Question</h5>
      <button type="button" (click)="editQuestionModalRef?.close()" aria-label="Close"
        style="background: none; border: none; padding: 0.5rem; cursor: pointer; opacity: 0.5; transition: opacity 0.2s;"
        (mouseenter)="$event.currentTarget.style.opacity = '1'"
        (mouseleave)="$event.currentTarget.style.opacity = '0.5'">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>

    <div class="modal-body" *ngIf="editQuestionForm?.length">
      <div class="edit-booking-question-card" *ngFor="let qn of editQuestionForm; let i = index">
        <div class="edit-booking-question-card__header" *ngIf="editQuestionForm.length > 1">
          <div class="edit-booking-question-card__header-title">
            <i class="fa-solid fa-question-circle me-2"></i>
            Question {{ i + 1 }}
          </div>
          <button class="edit-booking-question-card__remove" (click)="removeQuestionFromEditForm(i)">
            <i class="fa-solid fa-trash"></i>
          </button>
        </div>

        <div class="edit-booking-question-card__content">
          <div class="form-group">
            <label class="form-label">Question Text</label>
            <input type="text" class="form-control" [(ngModel)]="qn.questionText" placeholder="Enter question text" />
          </div>

          <div class="form-group">
            <label class="form-label">Answer Type</label>
            <select class="form-control py-0" [(ngModel)]="qn.type">
              <option value="text">Text Input</option>
              <option value="multipleChoice">Multiple Choice</option>
              <option value="singleDate">Single Date</option>
              <option value="dateRange">Date Range</option>
            </select>
          </div>

          <button *ngIf="qn.type === 'multipleChoice'" class="btn btn-outline-primary btn-sm"
            (click)="addChoiceToEditQuestion(i)">
            <i class="fa-solid fa-plus me-1"></i>
            Add Choice
          </button>
        </div>

        <!-- Multiple Choice Options -->
        <div class="edit-booking-choices" *ngIf="qn.type === 'multipleChoice'">
          <div class="edit-booking-choices__list">
            <div class="edit-booking-choice-item"
              *ngFor="let choice of qn.choices; let j = index; trackBy: trackByChoice">
              <input type="text" class="form-control" [(ngModel)]="qn.choices[j]" placeholder="Choice {{ j + 1 }}" />
              <button class="edit-booking-choice-item__remove" (click)="removeChoiceFromEditQuestion(i, j)">
                <i class="fa-solid fa-times"></i>
              </button>
            </div>
          </div>
          <div class="edit-booking-choices__empty" *ngIf="qn.choices.length === 0">
            <i class="fa-solid fa-info-circle me-2"></i>
            No choices yet — please add one.
          </div>
        </div>
      </div>

      <button class="btn btn-outline-primary w-100 mt-3" (click)="addNewQuestionToEditForm()">
        <i class="fa-solid fa-plus me-1"></i>
        Add Question
      </button>
    </div>

    <div class="modal-footer border-top pt-3">
      <button type="button" class="btn btn-outline-secondary" (click)="editQuestionModalRef?.close()">
        Cancel
      </button>
      <button type="button" class="btn btn-outline-primary" (click)="saveEditQuestion()">
        <i class="fa-solid fa-save mr-2"></i>Save Changes
      </button>
    </div>
  </div>
</ng-template>